// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-info[data-v-006cb69a]{max-width:557px;margin:0 auto}@media(max-width: 767.98px){.text-2xl[data-v-006cb69a]{font-size:1.25rem;line-height:2rem}}.text-xl[data-v-006cb69a]{line-height:1.75rem}@media(max-width: 1599.98px){.text-xl[data-v-006cb69a]{font-size:1.125rem;line-height:1.75rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
